import { render, staticRenderFns } from "./ChampCard.vue?vue&type=template&id=1ff0e23b&"
import script from "./ChampCard.vue?vue&type=script&lang=js&"
export * from "./ChampCard.vue?vue&type=script&lang=js&"
import style0 from "./ChampCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports